import Map, { Marker } from 'react-map-gl/mapbox'
import 'mapbox-gl/dist/mapbox-gl.css'
import { useState } from 'react'

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN

// initialLocation ({ lat, lng }) is optional: when given, the map opens on it
// with the marker already placed (used when editing a saved address)
function LocationPicker({ onLocationSelect, initialLocation }) {
  const [viewState, setViewState] = useState({
    latitude: initialLocation ? initialLocation.lat : 12.9716,
    longitude: initialLocation ? initialLocation.lng : 77.5946,
    zoom: initialLocation ? 14 : 12
  })

  const [selectedLocation, setSelectedLocation] = useState(initialLocation || null)
  const [search, setSearch] = useState('')
  const [results, setResults] = useState([])

  // 🔍 SEARCH
  const handleSearch = async (value) => {
    setSearch(value)

    if (!value) {
      setResults([])
      return
    }

    const res = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${value}.json?access_token=${MAPBOX_TOKEN}`
    )
    const data = await res.json()
    setResults(data.features || [])
  }

  const selectPlace = (place) => {
    const [lng, lat] = place.center

    setViewState({
      latitude: lat,
      longitude: lng,
      zoom: 14
    })

    setSelectedLocation({ lat, lng })
    setSearch(place.place_name)
    setResults([])

    onLocationSelect && onLocationSelect({ lat, lng })
  }

  const getCurrentLocation = async () => {
    navigator.geolocation.getCurrentPosition(async (pos) => {
      const lat = pos.coords.latitude
      const lng = pos.coords.longitude

      setViewState({
        latitude: lat,
        longitude: lng,
        zoom: 14
      })

      setSelectedLocation({ lat, lng })
      onLocationSelect && onLocationSelect({ lat, lng })
      try {
        const res = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_TOKEN}`
        )
        const data = await res.json()
        
        if (data.features && data.features.length > 0) {
          setSearch(data.features[0].place_name)
        }
      } catch (err) {
        console.error("Location fetch failed", err)
      }
    })
  }

  const handleClick = (e) => {
    const { lng, lat } = e.lngLat

    setSelectedLocation({ lat, lng })

    onLocationSelect && onLocationSelect({ lat, lng })
  }

  return (
    <div style={{ position: 'relative' }}>

      <div style={{
        position: 'absolute',
        top: 10,
        left: 10,
        right: 10,
        zIndex: 2
      }}>
        <input
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder="Search location..."
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            outline: 'none'
          }}
        />

        {results.length > 0 && (
          <div style={{
            background: 'white',
            maxHeight: 200,
            overflowY: 'auto',
            borderRadius: '6px',
            marginTop: '5px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            {results.map((r) => (
              <div
                key={r.id}
                onClick={() => selectPlace(r)}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee'
                }}
              >
                {r.place_name}
              </div>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={getCurrentLocation}
        style={{
          position: 'absolute',
          bottom: 10,
          right: 6,
          zIndex: 2,
          padding: '5px',
          borderRadius: '50%',
          background: 'white',
          border: '1px solid #ddd',
          cursor: 'pointer',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
        }}
      >
        {/* <svg width="20" height="20" viewBox="0 0 24 24">
          <path
            d="M12 2L19 21L12 17L5 21L12 2Z"
            fill="#4b2a0d"
          />
        </svg> */}
        <img src={`${process.env.PUBLIC_URL}/images/target.png`} alt="Current Location" style={{ width: 20, height: 20 }} />
      </button>

      <Map
        {...viewState}
        onMove={(evt) => setViewState(evt.viewState)}
        onClick={handleClick}
        style={{
          width: '100%',
          height: 300,
          borderRadius: '6px'
        }}
        attributionControl={false}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        mapboxAccessToken={MAPBOX_TOKEN}
      >

        {selectedLocation && (
          <Marker
            longitude={selectedLocation.lng}
            latitude={selectedLocation.lat}
            anchor="bottom"
          >
            <svg width="28" height="28" viewBox="0 0 24 24">
              <path
                d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z"
                fill="#4b2a0d"
              />
              <circle cx="12" cy="9" r="3" fill="white" />
            </svg>
          </Marker>
        )}

      </Map>

    </div>
  )
}

export default LocationPicker